import { Grid, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { MultiLangCodes } from '@components';
import { useCodeListSystem } from '@hooks/useCodeListSystem';
import { TSDViewGeneralInfoFormValues } from './validateTSDViewGeneralInfoForm';

interface TSDPlaceOfUnloadingSectionProps {
  form: UseFormReturnType<TSDViewGeneralInfoFormValues>;
  disabled: boolean;
}

export const TSDPlaceOfUnloadingSection: React.FC<TSDPlaceOfUnloadingSectionProps> = ({ form, disabled }) => {
  const codelistSystems = useCodeListSystem({});

  return (
    <Stack mb="xl">
      <Title order={5} fw={600}>
        Place of Unloading
      </Title>

      <Grid>
        <Grid.Col span={4}>
          <MultiLangCodes {...form.getInputProps('placeOfUnloading.UNLocode')} label="UNLOCODE" system={codelistSystems} code="CL244" disabled={disabled} />
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
